import React from 'react';
import PropTypes from 'prop-types';
import {
  GEOLOCATION_UK,
  GEOLOCATION_DE,
  GEOLOCATION_FR,
  GEOLOCATION_AU
} from '../constants';
import { Times } from './common/fa_icons';

const GEOLOCATION_TO_COUNTRY = {
  [GEOLOCATION_UK]: 'the UK',
  [GEOLOCATION_DE]: 'Germany',
  [GEOLOCATION_FR]: 'France',
  [GEOLOCATION_AU]: 'AU/NZ'
};

/*
 * Testing the Geolocation Banner
 * ==============================
 *
 * `props.geolocation` ultimately comes from the `X-Geolocation`
 * header. This header is set by the CDN based on the user's
 * geolocation (and there's some plumbing in `devops-neptune` to
 * ensure the header eventually makes its way to Rosetta).
 *
 * The client-side `gulp dev` does not have access to this header
 * and neither do devboxes. For those cases, you can simply pass in the
 * query param ?geo_override=(us|uk|de|fr|ca). You can also
 * pass this into prod to override the X-Geolocation header.
 *
 * Please do NOT post links containing this query param to the outside world,
 * since it changes web page content and we do not want it to be indexed
 * by Google.
 *
 * If we accidentally share a link with this query param, we should change
 * the query param.
 */

const GeolocationBanner = ({
  geolocation,
  onClick
}) => (
  <div className="geolocation-banner">
    <span className="geolocation-banner-text">
      We noticed you're in {GEOLOCATION_TO_COUNTRY[geolocation]}, would you like
      to see your local site? Click on the country / region above to switch.
    </span>
    <span className="geolocation-banner-close" onClick={onClick}>
      <Times />
    </span>
  </div>
);

GeolocationBanner.propTypes = {
  geolocation: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default GeolocationBanner;
